import { Component, OnInit, Input, AfterViewInit } from "@angular/core";
import { Router } from "@angular/router";
import { Storage } from "@ionic/storage";
import { STORAGE } from "../../../constant/storages";
import { _deleteStorage, _getStorage } from "../../../utils/local-storage";
import { AppService } from "../../../services/app.service";

@Component({
  selector: "app-manual-taxinvoice",
  templateUrl: "./manual-taxinvoice.page.html",
  styleUrls: ["./manual-taxinvoice.page.scss"],
})
export class ManualTaxinvoicePage implements OnInit {
  @Input() public actice: any;
  cardID = true;
  data: any;
  public appPages = [
    {
      title: "ค้นหาข้อมูลผู้ซื้อสินค้า",
      url: "/tax-invoice",
      icon: "mail",
      action: 1,
      checkroute: false,
    },
    {
      title: "ข้อมูลผู้ซื้อสินค้า",
      url: "/tax-invoice-select",
      icon: "paper-plane",
      action: 2,
      checkroute: false,
    },
    {
      title: "ค้นหาข้อมูลการซื้อสินค้า",
      url: "/tax-invoice-search-buy",
      icon: "heart",
      action: 3,
      checkroute: false,
    },
    {
      title: "บันทึกและส่งข้อมูล",
      url: "/tax-invoice-search-buy",
      action: 4,
      checkroute: true,
    },
    {
      title: "ออกใบกำกับภาษีสำเร็จ",
      url: "/tax-invoice-preview",
      action: 5,
      checkroute: true,
    },
  ];

  constructor(
    public router: Router,
    private appService: AppService,
    public storage: Storage
  ) {

  }

  ngOnInit() {
    this.appService.active.subscribe((value) => {
      this.actice = value;
    });
  }

  ionViewWillLeave() {
    _deleteStorage(STORAGE.DATA_ABB)
    _deleteStorage(STORAGE.DATA_SELECTTAXINVOICE)
    _deleteStorage(STORAGE.DATA_EDIT)
    _deleteStorage(STORAGE.DATA_PREVIEW_TAXINVOICE)
  }

  clickMenu(a) {
    let data = _getStorage(STORAGE.DATA_SELECTTAXINVOICE)
   
    if (a.action === 1) {
      this.ionViewWillLeave();
      this.router.navigate([a.url]);
    }

    if (a.action === 2) {
      if (data.length > 0) {
        this.appService.setActive(2)
        this.router.navigate([a.url]);
      } else {
        this.router.navigate([a.url]);
      }
    }
  }
}
